import {
  apiGetBillingConfigs,
  apiUpdateBillingConfig,
} from "@lib/api/settings";
import { UseQueriesProps } from "@lib/types/General";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

export const useBillingConfigQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true } = props;
  const queryKeys = queryKey || [
    "billing-config",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const billingConfigsQuery = useQuery({
    queryFn: () => apiGetBillingConfigs(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const updateBillingConfigMutation = useMutation({
    mutationFn: apiUpdateBillingConfig,
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.settings"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  return {
    billingConfigsQuery,
    updateBillingConfigMutation,
  };
};
